import { render, staticRenderFns } from "./BerthChartComponent.vue?vue&type=template&id=5abcd8d3&scoped=true"
import script from "./BerthChartComponent.vue?vue&type=script&lang=js"
export * from "./BerthChartComponent.vue?vue&type=script&lang=js"
import style0 from "./BerthChartComponent.vue?vue&type=style&index=0&id=5abcd8d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abcd8d3",
  null
  
)

export default component.exports